class DispatcherEvent {
    constructor(eventName) {
        this.eventName = eventName;
        this.callbacks = [];
    }

    registerCallback(callback) {
        this.callbacks.push(callback);
    }

    unregisterCallback(callback) {
        const index = this.callbacks.indexOf(callback);
        if (index > -1) {
            this.callbacks.splice(index, 1);
        }
    }

    fire(data) {
        // Looping over a cloned version of the array
        const callbacks = this.callbacks.slice(0);

        // Call each callback
        callbacks.forEach((callback) => {
            callback(data);
        });
    }
}

export default DispatcherEvent;